// extracted by mini-css-extract-plugin
export default {"top":"style_top__7VEot","profile":"style_profile__Gab6G","image":"style_image__YmOno","name":"style_name__PS-Q5","Shouts":"style_Shouts__h4jDY","options":"style_options__KKF9O"};